import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  write_address: { id: 'towingRecord.write_address', defaultMessage: 'Enter address' },
  job_end_success_message: { id: 'towingRecord.end.success.notification.message', defaultMessage: 'Job ended' },
  job_end_success_title: { id: 'towingRecord.end.success.notification.title', defaultMessage: 'Success' },
  job_end_error_message: { id: 'towingRecord.end.error.notification.message', defaultMessage: 'Failed to end job' },
  job_end_error_title: { id: 'towingRecord.end.error.notification.title', defaultMessage: 'Error' },
  tracking_autoliitto: {
    id: 'towingRecord.view.tracking.autoliitto',
    defaultMessage: 'Sijaintia lähetetään Autoliitolle',
  },
  tracking_sos_sending: {
    id: 'towingRecord.view.tracking.sos_sending',
    defaultMessage: 'Sijaintia lähetetään SOS:ille',
  },
  tracking_sos_pending: {
    id: 'towingRecord.view.tracking.sos_pending',
    defaultMessage: 'Sijainnin lähetys SOS:ille aloitetaan {seconds} sekunnin kuluttua',
  },
  end_job_button: { id: 'towingRecord.view.endJobButton', defaultMessage: 'Lopeta työ' },
  signature_button: { id: 'towingRecord.view.signatureButton', defaultMessage: 'Allekirjoitus' },
  take_photo_button: { id: 'towingRecord.view.takePhotoButton', defaultMessage: 'Ota kuva' },
})
